/**
 * Generate a reducer based on the provided handlers object.
 *
 * @param  initialState {mixed}    The previous state.
 * @param  handlers     {Object}   Available reducer functions – keyed by action type.
 * @return              {Function} Generic reducer which attaches arguments to specific new reducer.
 */
export default (initialState, handlers) =>
  (state = initialState, action) => {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }

    return state;
  };
